import { isMobileDevice } from '@srcDS/utils/detectBrowser';
import mergeClasses from '../../../utils/shallowMerge';
import Button from '../../atoms/button/Button';
import { CrossLine } from '../../atoms/icons';
import PrimaryLoader from '../../atoms/primaryLoader/PrimaryLoader';
import { Text } from '../../typography/text/Text';
import defaultClasses from './QuickAdd.module.scss';
import clsx from 'clsx';
import React from 'react';
import { useMedia } from 'react-use';
import { QuickAddProps } from './types';

export const QuickAdd: React.FC<QuickAddProps> = ({ 
  variants = [], 
  className, 
  customClasses = null, 
  sizeButtons 
}) => {
  const isMobileOrTablet = useMedia('(max-width: 1024px)', false);
  const styles = mergeClasses(defaultClasses, customClasses);

  return (
    !!variants.length && (
      <div className={clsx(styles.root, className)} data-quick-add-wrap="quick_add_wrap">
        <div className={styles.content}>
          <Text weight="semibold" className={styles.text}>
            QUICK ADD +
          </Text>
          <div className={styles.sizes}>
            {sizeButtons.map(({ key, label, isAvailable, isLoading, onClick }) => (
              /*@ts-ignore*/
              <Button
                className={styles.button}
                key={key}
                variant="primary"
                as="text"
                disabled={!isAvailable || isLoading}
                onClick={onClick}
              >
                <div className={!isAvailable ? styles.isOutOfStock : ''}>
                  {isLoading ? <PrimaryLoader mode="segment" size={12} /> : label}
                  {!isAvailable && <CrossLine />}
                </div>
              </Button>
            ))}
          </div>
          {(isMobileDevice || isMobileOrTablet) && <div className={styles.contentText}>tap size to add</div>}
        </div>
      </div>
    )
  );
};
